<script>
import ModalStudentComponent from '../../features/modals/ModalStudentComponent';
import ModalSelectCareerView from './ModalSelectCareerView';

export default {
  name: 'ModalStudentView',
  components: {
    'modal-select-career-view': ModalSelectCareerView,
  },
  extends: ModalStudentComponent,
  computed: {
    isUpdate() {
      return Boolean(this.formData?.id || this.formData?.state === 'update');
    },
    modalTitle() {
      return this.isUpdate ? 'Actualizar Perfil de Estudiante' : 'Registrar Nuevo Estudiante';
    },
    modalSubtitle() {
      return this.isUpdate
        ? 'Actualiza los datos personales, de acceso y preferencias académicas'
        : 'Completa la información requerida para registrar un nuevo estudiante en la plataforma';
    },
  },
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    class="subscription-account-modal student-profile-modal"
    width="920px"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <!-- Cabecera estandarizada -->
    <template #header>
      <div class="student_modal_header">
        <div class="student_modal_header_icon">
          <i class="fas fa-id-card" />
        </div>
        <div class="student_modal_header_info">
          <h3 class="student_modal_title">
            {{ modalTitle }}
          </h3>
          <p class="student_modal_subtitle">
            {{ modalSubtitle }}
          </p>
        </div>
      </div>
    </template>

    <!-- Formulario principal -->
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      label-position="top"
    >
      <el-tabs
        v-model="activeName"
        class="student_tabs"
      >
        <!-- Pestaña 1: Cuenta y Acceso -->
        <el-tab-pane
          name="account"
        >
          <template #label>
            <span><i class="fas fa-user-lock" /> Cuenta y Acceso</span>
          </template>

          <!-- Tarjeta de Foto de Perfil -->
          <div class="student_avatar_card">
            <div class="student_avatar_wrapper">
              <img
                :src="profileImageUrl || '/images/left-imgs/img-1.jpg'"
                class="student_avatar_img"
                alt="Foto de perfil"
              >
            </div>
            <div class="student_avatar_details">
              <h5 class="student_avatar_title">
                Foto de Perfil
              </h5>
              <p class="student_avatar_desc">
                Sube una imagen cuadrada (JPG, PNG). Se mostrará en tu perfil, actividades y constancias.
              </p>
              <div class="student_avatar_actions">
                <el-upload
                  action=""
                  :show-file-list="false"
                  :on-success="onSuccessHandlerProfilePicture"
                  :before-upload="onBeforeUploadHandlerProfilePicture"
                >
                  <el-button
                    size="small"
                    class="btn_upload_avatar"
                  >
                    <i class="fas fa-camera" /> Cambiar Foto
                  </el-button>
                </el-upload>
                <el-tag
                  v-if="isProfileImageTemp"
                  size="small"
                  type="warning"
                  effect="light"
                >
                  <i class="fas fa-clock" /> Imagen temporal (sin guardar)
                </el-tag>
                <el-tag
                  v-else
                  size="small"
                  type="success"
                  effect="light"
                >
                  <i class="fas fa-check-circle" /> Foto actual
                </el-tag>
              </div>
            </div>
          </div>

          <!-- Estado de la cuenta (solo en modo admin/gestión) -->
          <div
            v-if="showStatus"
            class="student_status_card"
          >
            <div class="status_info">
              <span class="status_title">Estado del Estudiante</span>
              <span class="status_desc">Define si el usuario puede acceder a la plataforma y sus contenidos</span>
            </div>
            <el-switch
              v-model="formData.userProfile.status"
              active-color="#10B981"
              inactive-color="#EF4444"
              active-text="Activo"
              inactive-text="Inactivo"
              :active-value="2"
              :inactive-value="1"
            />
          </div>

          <!-- Bloque de Nombres y Credenciales -->
          <div class="student_card_box">
            <h5 class="student_card_title">
              <i class="fas fa-user-circle" /> Datos de Identificación
            </h5>
            <el-row :gutter="20">
              <el-col
                :xs="24"
                :sm="12"
              >
                <el-form-item
                  label="Nombre(s)"
                  prop="userProfile.firstName"
                >
                  <el-input
                    v-model="formData.userProfile.firstName"
                    maxlength="70"
                    placeholder="Ej. Juan Carlos"
                    clearable
                  >
                    <template #prefix>
                      <i class="fas fa-user el-input__icon" />
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
              >
                <el-form-item
                  label="Apellido(s)"
                  prop="userProfile.lastName"
                >
                  <el-input
                    v-model="formData.userProfile.lastName"
                    maxlength="70"
                    placeholder="Ej. Pérez González"
                    clearable
                  >
                    <template #prefix>
                      <i class="fas fa-user el-input__icon" />
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col
                :xs="24"
                :sm="12"
              >
                <el-form-item
                  label="Correo Electrónico"
                  prop="userProfile.email"
                >
                  <el-input
                    v-model="formData.userProfile.email"
                    placeholder="estudiante@correo.com"
                    clearable
                  >
                    <template #prefix>
                      <i class="fas fa-envelope el-input__icon" />
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
              >
                <el-form-item
                  label="Usuario"
                  prop="userProfile.userName"
                >
                  <el-input
                    v-model="formData.userProfile.userName"
                    placeholder="juan.perez"
                    clearable
                  >
                    <template #prefix>
                      <i class="fas fa-at el-input__icon" />
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- Configuración de Contraseña -->
            <div
              class="password_config_box"
              :class="{ 'is-enabled': updatePassword || !formData.id }"
            >
              <div
                v-if="formData.id"
                class="password_config_header"
              >
                <el-checkbox v-model="updatePassword">
                  Actualizar Contraseña de Acceso
                </el-checkbox>
              </div>

              <el-row :gutter="20">
                <el-col
                  :xs="24"
                  :sm="12"
                >
                  <el-form-item
                    label="Contraseña"
                    prop="userProfile.password"
                  >
                    <el-input
                      v-model="formData.userProfile.password"
                      type="password"
                      show-password
                      placeholder="••••••••"
                      :disabled="!isPasswordRequired()"
                    >
                      <template #prefix>
                        <i class="fas fa-lock el-input__icon" />
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="24"
                  :sm="12"
                >
                  <el-form-item
                    label="Verificar Contraseña"
                    prop="userProfile.checkPass"
                  >
                    <el-input
                      v-model="formData.userProfile.checkPass"
                      type="password"
                      show-password
                      placeholder="••••••••"
                      :disabled="!isPasswordRequired()"
                    >
                      <template #prefix>
                        <i class="fas fa-check-double el-input__icon" />
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <p class="password_hint">
                <i class="fas fa-shield-alt" /> Mínimo 4 caracteres alfanuméricos (@ . - _)
              </p>
            </div>
          </div>
        </el-tab-pane>

        <!-- Pestaña 2: Información Personal -->
        <el-tab-pane
          name="personal"
        >
          <template #label>
            <span><i class="fas fa-address-book" /> Datos Personales</span>
          </template>

          <div class="student_card_box">
            <h5 class="student_card_title">
              <i class="fas fa-phone-alt" /> Teléfonos y Redes Sociales
            </h5>
            <el-row :gutter="20">
              <el-col
                :xs="24"
                :sm="12"
              >
                <el-form-item
                  label="Teléfono de Hogar"
                  prop="homePhone"
                >
                  <el-input
                    v-model.number="formData.homePhone"
                    placeholder="Ej. 5512345678"
                    clearable
                  >
                    <template #prefix>
                      <i class="fas fa-phone el-input__icon" />
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
              >
                <el-form-item
                  label="Teléfono Celular"
                  prop="cellPhone"
                >
                  <el-input
                    v-model.number="formData.cellPhone"
                    placeholder="Ej. 5587654321"
                    clearable
                  >
                    <template #prefix>
                      <i class="fas fa-mobile-alt el-input__icon" />
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col
                :xs="24"
                :sm="12"
              >
                <el-form-item
                  label="Página de Facebook"
                  prop="pageUrlFacebook"
                >
                  <el-input
                    v-model="formData.pageUrlFacebook"
                    placeholder="https://facebook.com/usuario"
                    clearable
                  >
                    <template #prefix>
                      <i class="fab fa-facebook-f el-input__icon" />
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
              >
                <el-form-item
                  label="Página de Instagram"
                  prop="pageUrlInstagram"
                >
                  <el-input
                    v-model="formData.pageUrlInstagram"
                    placeholder="https://instagram.com/usuario"
                    clearable
                  >
                    <template #prefix>
                      <i class="fab fa-instagram el-input__icon" />
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="student_card_box">
            <h5 class="student_card_title">
              <i class="fas fa-map-marker-alt" /> Domicilio y Presentación
            </h5>
            <el-form-item
              label="Dirección de Domicilio"
              prop="homeAddress"
            >
              <el-input
                v-model="formData.homeAddress"
                type="textarea"
                :rows="2"
                maxlength="255"
                show-word-limit
                placeholder="Calle, número, colonia, código postal y ciudad"
              />
            </el-form-item>

            <el-form-item
              label="Acerca de ti"
              prop="about"
            >
              <el-input
                v-model="formData.about"
                type="textarea"
                :rows="3"
                maxlength="255"
                show-word-limit
                placeholder="Cuéntanos un poco sobre tus metas, intereses o aspiraciones vocacionales..."
              />
            </el-form-item>
          </div>
        </el-tab-pane>

        <!-- Pestaña 3: Perfil Académico (Administración / Creación) -->
        <el-tab-pane
          v-if="!formData.isStudent"
          name="academic"
        >
          <template #label>
            <span><i class="fas fa-graduation-cap" /> Perfil Académico</span>
          </template>

          <div class="student_card_box">
            <div class="student_section_header">
              <h4 class="student_section_title">
                <i class="fas fa-university" /> Carreras Universitarias de Interés
              </h4>
              <el-button
                type="primary"
                size="small"
                class="btn_section_action"
                @click="onSelectCareers"
              >
                <i class="fas fa-plus" /> Seleccionar Carreras
              </el-button>
            </div>

            <el-table
              v-loading="isItemLoading"
              :data="formData.careers"
              class="student_careers_table"
              width="100%"
              max-height="270"
              empty-text="No has seleccionado carreras de interés aún"
            >
              <el-table-column
                prop="name"
                label="Carrera"
                min-width="220"
              >
                <template #default="scope">
                  <span class="career_name_cell">{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Área"
                min-width="180"
              >
                <template #default="scope">
                  <el-tag
                    size="small"
                    effect="plain"
                    class="career_tag"
                  >
                    {{ scope.row.knowledgeArea?.name || 'General' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="Universidad"
                min-width="200"
              >
                <template #default="scope">
                  <span>{{ scope.row.university?.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Acciones"
                width="110"
                align="center"
              >
                <template #default="scope">
                  <el-button
                    size="small"
                    type="danger"
                    plain
                    circle
                    title="Eliminar carrera"
                    @click="onDeleteCareer(scope.$index)"
                  >
                    <i class="fas fa-trash-alt" />
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-form-item
              label="Preparatoria que cursa o cursó"
              prop="highSchool"
            >
              <el-select
                v-model="formData.highSchool"
                allow-create
                clearable
                filterable
                remote
                :remote-method="onSearchHighSchools"
                placeholder="Buscar o escribir nombre de preparatoria..."
                value-key="id"
                style="width: 100%"
                @change="onChangeSelectHighSchools"
              >
                <el-option
                  v-for="item in highSchools"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </div>

          <div class="student_card_box">
            <h5 class="student_card_title">
              <i class="fas fa-clipboard-list" /> Cuestionario Vocacional y Observaciones
            </h5>

            <el-form-item
              label="¿Por qué quiere estudiar la carrera seleccionada?"
              prop="selectedCareerObservation"
            >
              <el-input
                v-model="formData.selectedCareerObservation"
                type="textarea"
                :rows="2"
                maxlength="255"
                show-word-limit
                placeholder="Motivaciones e interés por la carrera..."
              />
            </el-form-item>

            <el-form-item
              label="¿Qué espera de esta asesoría?"
              prop="advisoryObservation"
            >
              <el-input
                v-model="formData.advisoryObservation"
                type="textarea"
                :rows="2"
                maxlength="255"
                show-word-limit
                placeholder="Expectativas del acompañamiento académico..."
              />
            </el-form-item>

            <el-form-item
              label="¿Qué materia se le dificulta más entre matemáticas y español? y ¿Por qué?"
              prop="subjectComplicationObservation"
            >
              <el-input
                v-model="formData.subjectComplicationObservation"
                type="textarea"
                :rows="2"
                maxlength="255"
                show-word-limit
                placeholder="Materia y motivos de dificultad..."
              />
            </el-form-item>

            <div class="student_status_card">
              <div class="status_info">
                <span class="status_title">¿Padece de alguna enfermedad o condición especial?</span>
                <span class="status_desc">Información relevante para adaptaciones académicas o de salud</span>
              </div>
              <el-switch
                v-model="formData.hasDiseaseOrSpecialCondition"
                active-color="#10B981"
                inactive-color="#94A3B8"
                active-text="Sí"
                inactive-text="No"
                :active-value="true"
                :inactive-value="false"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <!-- Footer personalizado del modal -->
    <template #footer>
      <div class="student_modal_footer">
        <span class="footer_note">
          <i class="fas fa-shield-alt mr-1" />
          Los datos del estudiante se almacenan de manera segura en la plataforma
        </span>
        <div class="footer_actions">
          <el-button
            class="btn_cancel_student_modal"
            @click="onCancel"
          >
            <i class="fas fa-times mr-1" /> Cancelar
          </el-button>
          <el-button
            type="primary"
            :loading="conf.isLoading"
            :disabled="!onCanSaveOrUpdate()"
            class="btn_submit_student_info"
            @click="onSubmitForm('formData')"
          >
            <i class="fas fa-save mr-2" /> {{ isUpdate ? 'Guardar Cambios' : 'Registrar Estudiante' }}
          </el-button>
        </div>
      </div>
    </template>

    <modal-select-career-view
      v-if="modalItemCareers.isVisible"
      :form-data="itemCareers"
      :conf="modalItemCareers"
    />
  </el-dialog>
</template>
